import '../sass/image-carousel-with-text.scss';

(() => {
    const swiperScript = document.querySelector('#ofg-education-swiper-js');
    const $blocks = document.querySelectorAll('.block.image-carousel-with-text');

    if (!$blocks) return;

    $blocks.forEach($block => {
        const $carousel = $block.querySelector('.image-carousel-with-text__carousel');
        const $carouselNavigationPrev = $block.querySelector('.image-carousel-with-text__controls-navigation--prev');
        const $carouselNavigationNext = $block.querySelector('.image-carousel-with-text__controls-navigation--next');
        const slideCount = $carousel?.querySelectorAll('.swiper-slide').length ?? 0;

        const initCarousel = () => {
            if (!$carousel || slideCount <= 1) return;

            new Swiper($carousel, {
                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                },
                loop: true,
                speed: 600,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                },
                navigation: {
                    prevEl: $carouselNavigationPrev,
                    nextEl: $carouselNavigationNext,
                },
            });
        };

        if (typeof Swiper !== 'undefined') {
            initCarousel();
        } else if (swiperScript) {
            swiperScript.addEventListener('load', () => {
                initCarousel();
            });
        } else {
            window.addEventListener('load', () => {
                const swiperScript = document.querySelector('#ofg-education-swiper-js');

                if (!swiperScript) return;

                initCarousel();
            });
        }
    });
})();
